import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
/**
 * 范围输入框组件，继承Base
 * @module $ui/components/my-range
 */

import { DatePicker, InputNumber, TimeSelect } from 'element-ui';
import Base from '../Base';
export default {
  name: 'MyRange',
  mixins: [Base],
  components: {
    InputNumber: InputNumber,
    DatePicker: DatePicker,
    TimeSelect: TimeSelect
  },
  props: {
    // 值
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 模式
    mode: {
      type: String,
      default: 'number',
      validator: function validator(val) {
        return ['number', 'time', 'date'].includes(val);
      }
    },
    // 分隔符
    separator: {
      type: String,
      default: '-'
    }
  },
  data: function data() {
    return {
      min: '',
      max: ''
    };
  },
  watch: {
    fieldValue: {
      immediate: true,
      handler: function handler(val) {
        this.min = val[0] || (this.mode === 'number' ? 0 : '');
        this.max = val[1] || (this.mode === 'number' ? 0 : '');
      }
    },
    min: function min(val) {
      this.fieldValue = [val, this.max];
      this.$emit('change', this.fieldValue);
    },
    max: function max(val) {
      this.fieldValue = [this.min, val];
      this.$emit('change', this.fieldValue);
    }
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      if (this.mode === 'number') {
        return [0, 0];
      } else {
        return ['', ''];
      }
    },
    createSeparator: function createSeparator() {
      var h = this.$createElement;
      return h("span", {
        "class": 'my-range__separator'
      }, [this.separator]);
    },
    renderNumber: function renderNumber() {
      var _this = this;
      var h = this.$createElement;
      return [h(InputNumber, {
        "class": 'my-range__input',
        "props": _objectSpread({}, this.innerProps),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this.min,
          callback: function callback($$v) {
            _this.min = $$v;
          }
        }
      }), this.createSeparator(), h(InputNumber, {
        "class": 'my-range__input',
        "props": _objectSpread({}, this.innerProps),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this.max,
          callback: function callback($$v) {
            _this.max = $$v;
          }
        }
      })];
    },
    renderDate: function renderDate() {
      var _this2 = this;
      var h = this.$createElement;
      return [h(DatePicker, {
        "class": 'my-range__input',
        "props": _objectSpread({}, this.innerProps),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this2.min,
          callback: function callback($$v) {
            _this2.min = $$v;
          }
        }
      }), this.createSeparator(), h(DatePicker, {
        "class": 'my-range__input',
        "props": _objectSpread({}, this.innerProps),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this2.max,
          callback: function callback($$v) {
            _this2.max = $$v;
          }
        }
      })];
    },
    renderTime: function renderTime() {
      var _this3 = this;
      var h = this.$createElement;
      return [h(TimeSelect, {
        "class": 'my-range__input',
        "props": _objectSpread({}, this.innerProps),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this3.min,
          callback: function callback($$v) {
            _this3.min = $$v;
          }
        }
      }), this.createSeparator(), h(TimeSelect, {
        "class": 'my-range__input',
        "props": _objectSpread({}, this.innerProps),
        "attrs": _objectSpread({}, this.innerProps),
        "model": {
          value: _this3.max,
          callback: function callback($$v) {
            _this3.max = $$v;
          }
        }
      })];
    }
  },
  render: function render() {
    var h = arguments[0];
    var map = {
      number: this.renderNumber,
      date: this.renderDate,
      time: this.renderTime
    };
    var vnode = h("div", {
      "class": 'my-range'
    }, [map[this.mode]()]);
    return this.renderComponent(vnode);
  }
};